<div class="cart-container" #globalCartContainer>
  <div class="align-items-start global-cart-tireconnect-section">
    <!-- Cart details header` -->
    <div class="cart-header py-1 tire-border-bottom">
      <div class="flex-between-center p-2 pr-3 pl-3">
        <div class="flex-row">
          <img class="mr-1" src="assets/img/cart-plus.svg" alt="cart logo" />
          <span class="font-18 font-700 flex-start-center">Cart</span>
        </div>

        <span class="close-modal pointer" (click)="handleCloseCart()">
          <i class="fal fa-times"></i>
        </span>
      </div>
    </div>

    <div class="cart-body px-0 pt-0 pb-3 w-100 flex-row">

      <div class="w-100 p-2 flex-column gap-2">
          <p-accordion class="cart-product-qtq" [multiple]="false">
            <p-accordionTab *ngFor="let globalCartItem of globalCartItemList">
              <p-header>
                <div class="flex-between-center">
                  <div class="flex-start-center">
                    <img class="mr-1 ml-1" [src]="displayDetails[globalCartItem?.source]?.logo" [alt]="displayDetails[globalCartItem?.source]?.logo" />
                    <span class="font-16 font-600">{{displayDetails[globalCartItem?.source]?.heading}}</span>
                  </div>
                  <div class="flex-between-center w-60">
                    <div class="flex-center-center gap-2" [hidden]="hideCost">
                      <span class="font-14 font-400 font-secondary">Total est. cost:</span>
                      <span class="font-14 font-600">{{globalCartItem?.cartSummary?.total | currency: usd}}</span>
                    </div>

                    <div class="flex-center-center gap-2" *ngIf="(isOpenFromQuickTireLookup || isOpenFromRO) && hideCost">
                      <span class="font-14 font-400 font-secondary">Total est. price:</span>
                      <span class="font-14 font-600">{{globalCartItem?.cartSummary?.totalPrice | currency: usd}}</span>
                    </div>

                    <div class="flex-center-center gap-2">
                      <span class="font-14 font-400 font-secondary">Total est. shipping:</span>
                      <span class="font-14 font-600">{{globalCartItem?.cartSummary?.shippingCost | currency: usd}}</span>
                    </div>

                    <div class="flex-center-center gap-2" *ngIf="hideCost">
                      <span class="font-14 font-400 font-secondary">Taxes:</span>
                      <span class="font-14 font-600">{{(globalCartItem?.cartSummary?.totalTaxAmount + globalCartItem?.cartSummary?.totalFetValue || 0) | currency: usd}}</span>
                    </div>

                    <div class="flex-center-center gap-2">
                      <span class="font-14 font-400 font-secondary">{{displayDetails[globalCartItem?.source]?.heading}} total:</span>
                      <span class="font-14 font-700" [hidden]="hideCost">{{globalCartItem?.cartSummary?.grand | currency: usd}}</span>
                      <span class="font-14 font-700" [hidden]="!hideCost">{{globalCartItem?.cartSummary?.grandPrice | currency: usd}}</span>
                    </div>
                  </div>
                </div>


              </p-header>
              <div class="flex-row">
                <div class="cart-left-section flex-column w-60 pr-3">
                  <div class="cart-left-wrapper flex-column">
                    <span class="font-700 font-18 pb-3">Order details</span>
                    <!-- Warehouse -->
                    <p-accordion class="cart-product" [multiple]="true">
                      <p-accordionTab *ngFor="let warehouse of globalCartItem?.cartitemList; let itemIndex = index">
                        <!-- Warehouse header -->
                        <p-header>
                          <span class="flex-start-center">
                            <span *ngIf="warehouse?.supplier?.name">{{warehouse?.supplier?.name}}&nbsp;-&nbsp;</span>
                            <span>{{warehouse?.warehouseName}}</span>
                          </span>
                        </p-header>

                        <!-- Warehouse body -->
                        <div *ngFor="let item of warehouse?.tires" class="supplier-body flex-column">
                          <div class="supplier-card mb-2">
                            <!-- header -->
                            <div class="flex-between-center flex-row supplier-card-header">
                              <span class="font-14 font-600">{{item?.title}}</span>
                              <button class="btn btn-remove-icon" (click)="handleTireSelect(item?.orderItemId, null, globalCartItem?.source)"
                                *ngIf="globalCartItem?.source !== 'autoleap'">
                                <i class="fa fa-trash"></i>
                              </button>
                              <button class="btn btn-remove-icon" (click)="handleTireSelect(item?._id, null, globalCartItem?.source)"
                                *ngIf="globalCartItem?.source === 'autoleap' && isOpenFromQuickTireLookup">
                                <i class="fa fa-trash"></i>
                              </button>
                            </div>

                            <!-- body -->
                            <div class="supplier-card-body flex-row">
                              <div class="tire-img-section flex-center-center">
                                <img [src]="item?.image"
                                  onerror="this.onerror=null;this.src='assets/img/tireconnect-tire.png';" />
                              </div>

                              <div class="flex-column w-100">
                                <div class="tire-specs-section">
                                  <p>
                                    Tire size
                                    <span>{{item?.size}}</span>
                                  </p>

                                  <p>
                                    Item no.
                                    <span>{{item?.partNumber}}</span>
                                  </p>

                                  <p class="text-right">
                                    Warranty
                                    <span>{{item?.warranty}} mi</span>
                                  </p>
                                </div>

                                <div class="tire-specs-section">
                                  <p>
                                    Available
                                    <span>{{item?.countAvailable}} tires</span>
                                  </p>

                                  <div class="flex-column">
                                    <div class="qty-box" [ngClass]="{
                                      'qty-box-border-error': item?.error,
                                      'qty-box-border': !item?.error
                                    }">
                                      QTY:
                                      <app-input *ngIf="globalCartItem?.source !== 'autoleap'" placeholder="0" textAlign="right" theme="light"
                                        [value]="item?.count" mask="00" [isInvalid]="item?.error" [selectTextOnFocus]="true"
                                        (appFocus)="handleFocus(item?.orderItemId)" (appBlur)="handleBlur(item?.orderItemId)"
                                        (appChange)="handleCountChange(item?.orderItemId, $event, item, globalCartItem?.source)"></app-input>

                                      <app-input *ngIf="globalCartItem?.source === 'autoleap'" placeholder="0"
                                        textAlign="right" theme="light" [value]="item?.count" mask="00" [isInvalid]="item?.error"
                                        [selectTextOnFocus]="true" (appFocus)="handleFocus(item?._id)"
                                        (appBlur)="handleBlur(item?._id)"
                                        (appChange)="handleCountChange(item?._id, $event, item, globalCartItem?.source)"></app-input>

                                    </div>
                                    <span *ngIf="item?.errorMsgQty" class="qty-error-msg">{{item?.errorMsgQty}}</span>
                                  </div>


                                  <p class="text-right" [hidden]="hideCost">
                                    Est. Cost (per tire)
                                    <span>{{item?.cost}}</span>
                                  </p>

                                  <p class="text-right" *ngIf="(isOpenFromQuickTireLookup || isOpenFromRO) && hideCost">
                                    Est. Price (per tire)
                                    <span>{{item?.price}}</span>
                                  </p>
                                </div>
                              </div>
                            </div>

                            <!-- Footer -->
                            <div class="supplier-footer flex-row"
                              [ngClass]="globalCartItem?.source === 'tireconnect' ?  'flex-between-center' : 'flex-end-center'">
                              <!-- {{warehouse?.supplierFields?.length > 1? 'Multiple': 'Single'}} -->
                              <div class="flex-column width-100p">
                                <ng-container *ngIf="!warehouse?.supplierFields?.length else mSupplierField">
                                  <div class="w-40 supplier-footer-dd" [hidden]="!(globalCartItem?.source === 'tireconnect')">
                                    <app-dropdown theme="border" id="delivery-method-dd" listId="delivery-method-dd-list"
                                      placeholder="Delivery method:" field="label" position="top" [hasError]="item?.deliveryMethodError"
                                      [isLoading]="warehouse?.supplier?.isSupplierListLoading" scrollHeight="140px"
                                      [fontSize]="12" [listItemFontSize]="12" [floatingLabel]="false"
                                      [options]="warehouse?.options" [value]="warehouse?.delivery?.option"
                                      [isDropdownIconVisible]="true" (appSelect)="handleDeliverSelect(warehouse, $event, item, null, globalCartItem?.source)"
                                      (appOpenDropdown)="getSupplierFields(warehouse, globalCartItem?.source)">
                                    </app-dropdown>
                                  </div>
                                </ng-container>

                                <ng-template #mSupplierField>
                                  <ng-container
                                    *ngFor="let supplierField of warehouse?.supplierFields; let supplierIndex = index">
                                    <div class="mb-2 w-40 supplier-footer-dd" [hidden]="!(globalCartItem?.source === 'tireconnect')">
                                      <app-dropdown theme="border" id="delivery-method-dd-{{supplierIndex}}"
                                        listId="delivery-method-dd-list-{{supplierIndex}}" placeholder="{{supplierField?.label}}:"
                                        field="text" position="top" [truncateString]="true"
                                        [isLoading]="warehouse?.supplier?.isSupplierListLoading" scrollHeight="140px"
                                        [fontSize]="12" [listItemFontSize]="12" [floatingLabel]="false"
                                        [options]="supplierField?.options"
                                        [hasError]="tireConnectErrors[supplierField?.attributes?.name]?.deliveryMethodError"
                                        [value]="getSelectedValue(warehouse?.selectedSupplierFields, supplierField?.attributes?.name)"
                                        [isDropdownIconVisible]="true"
                                        (appSelect)="handleDeliverSelect(warehouse, $event, item, supplierField, globalCartItem?.source)"
                                        (appOpenDropdown)="getSupplierFields(warehouse, globalCartItem?.source)">
                                      </app-dropdown>
                                    </div>
                                  </ng-container>
                                </ng-template>
                              </div>

                              <!-- <div class="w-40 supplier-footer-dd" [hidden]="!(source === 'tireconnect')">
                                <app-dropdown theme="border" id="delivery-method-dd" listId="delivery-method-dd-list"
                                  placeholder="Delivery method:" field="label" position="top"
                                  [isLoading]="warehouse?.supplier?.isSupplierListLoading" scrollHeight="140px" [fontSize]="12"
                                  [listItemFontSize]="12" [floatingLabel]="false" [options]="warehouse?.options"
                                  [value]="warehouse?.delivery?.option" [isDropdownIconVisible]="true"
                                  (appSelect)="handleDeliverSelect(warehouse, $event, item)"
                                  (appOpenDropdown)="getSupplierFields(warehouse)">
                                </app-dropdown>
                              </div> -->
                              <div class="flex-row flex-center" [hidden]="hideCost">
                                <span class="font-14 font-400">Est. Total Cost:</span>
                                <span class="font-18 font-700 font-primary">
                                  &nbsp; {{item?.cost * item.count | currency: usd}}
                                </span>
                              </div>
                              <div class="flex-row flex-center" *ngIf="(isOpenFromQuickTireLookup || isOpenFromRO) && hideCost">
                                <span class="font-14 font-400">Est. Total Price:</span>
                                <span class="font-18 font-700 font-primary">
                                  &nbsp; {{item?.price * item.count | currency: usd}}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                </div>

                <!-- Cart right section -->
                <div class="cart-right-section w-40 pl-3">
                  <div class="cart-right-wrapper">
                    <div class="cart-upper-section flex-column">
                      <p class="font-14 font-600">Order summary</p>

                      <div *ngFor="let warehouse of globalCartItem?.cartitemList; let itemIndex = index" class="added-tire flex-column mb-3">
                        <div class="">
                          <span class="font-14 font-600">
                            <span *ngIf="warehouse?.supplier?.name">{{warehouse?.supplier?.name}}&nbsp;-&nbsp;</span>
                            <span>{{warehouse?.warehouseName}}</span>
                          </span>
                        </div>

                        <div class="flex-row flex-between-center" [hidden]="hideCost">
                          <span class="font-14 font-400 font-secondary">Est. cost</span>
                          <span class="font-16 font-600">{{warehouse?.total?.cost || 0 | currency: usd}}</span>
                        </div>

                        <div class="flex-row flex-between-center" *ngIf="(isOpenFromQuickTireLookup || isOpenFromRO) && hideCost">
                          <span class="font-14 font-400 font-secondary">Est. price</span>
                          <span class="font-16 font-600">{{warehouse?.total?.price || 0 | currency: usd}}</span>
                        </div>

                        <div class="flex-row flex-between-center">
                          <span class="font-14 font-400 font-secondary">Est. shipping</span>
                          <i *ngIf="shippingLoader[warehouse?.warehouseId]" class="fal fa-spinner rotate ml-1"></i>
                          <span *ngIf="!shippingLoader[warehouse?.warehouseId]">
                            {{warehouse?.total?.shippingCost || 0 | currency: usd}}
                          </span>
                        </div>

                        <div class="flex-row flex-between-center" *ngIf="isPassThroughTaxEnable">
                          <span class="font-14 font-400 font-secondary">FET</span>
                          <span>{{warehouse?.total?.totalFetValue || 0 | currency: usd}}</span>
                        </div>

                        <div class="flex-row flex-between-center" *ngIf="hideCost">
                          <span class="font-14 font-400 font-secondary">SalesTax ({{this.selectedTax?.name}})</span>
                          <span>{{warehouse?.total?.totalTaxAmount || 0 | currency: usd}}</span>
                        </div>

                        <div class="flex-row flex-between-center" [hidden]="hideCost">
                          <span class="font-14 font-400 font-secondary">Order total</span>
                          <span class="font-16 font-700" *ngIf="isPassThroughTaxEnable">{{(warehouse?.total?.total + warehouse?.total?.totalFetValue) || 0 | currency: usd}}</span>
                          <span class="font-16 font-700" *ngIf="!isPassThroughTaxEnable">{{(warehouse?.total?.total) || 0 | currency: usd}}</span>
                        </div>

                        <div class="flex-row flex-between-center" *ngIf="(isOpenFromQuickTireLookup || isOpenFromRO) && hideCost">
                          <span class="font-14 font-400 font-secondary">Order total price</span>
                          <span class="font-16 font-700" *ngIf="isPassThroughTaxEnable">{{(warehouse?.total?.totalPrice + warehouse?.total?.totalTaxAmount + warehouse?.total?.totalFetValue) || 0 | currency: usd}}</span>
                          <span class="font-16 font-700" *ngIf="!isPassThroughTaxEnable">{{(warehouse?.total?.totalPrice + warehouse?.total?.totalTaxAmount) || 0 | currency: usd}}</span>
                        </div>

                      </div>
                    </div>

                    <div class="cart-bottom-section flex-column" [hidden]="hideCost">
                      <div class="flex-row order-info flex-start-center mt-1">
                        <i class="fa fa-exclamation-triangle icon-warning" aria-hidden="true"></i>
                        <span class="font-12 font-400 pl-2">
                          Order total does not include taxes associated with this order
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </p-accordionTab>

          </p-accordion>
          <p-accordion class="cart-product-qtq" [activeIndex]="0">
            <!-- Add on services section -->
            <p-accordionTab class="mb-3">
              <p-header>
                <div class="flex-between-center">
                  <div class="flex-start-center">
                    <img class="mr-1 ml-1" src="assets/img/service-adon.svg" alt="Add on service" />
                    <span class="font-16 font-600">Services</span>
                  </div>
                  <div class="flex-between-center w-75 gap-2">
                    <div class="flex-center-center gap-2" [hidden]="hideCost">
                      <span class="font-14 font-400 font-secondary">Total est. cost:</span>
                      <span class="font-14 font-600">{{ (isEditMode ? globalCartSelctedService?.serviceTotal?.serviceTotalCost : selectedAdonService?.serviceTotal?.serviceTotalCost) || 0 | currency: usd}}</span>
                    </div>

                    <div class="flex-center-center gap-2">
                      <span class="font-14 font-400 font-secondary">Total est. price:</span>
                      <span class="font-14 font-700">{{(isEditMode ? globalCartSelctedService?.serviceTotal?.serviceTotalPrice :  selectedAdonService?.serviceTotal?.serviceTotalPrice) || 0 | currency: usd}}</span>
                    </div>

                    <div class="flex-center-center gap-2">
                      <span class="font-14 font-400 font-secondary">Taxes:</span>
                      <span class="font-14 font-700">{{(isEditMode ? globalCartSelctedService?.serviceTotal?.serviceTotalTax :  selectedAdonService?.serviceTotal?.serviceTotalTax) || 0 | currency: usd}}</span>
                    </div>

                    <div class="flex-center-center gap-2">
                      <span class="font-14 font-400 font-secondary">Service total:</span>
                      <span class="font-14 font-700">{{(isEditMode ? globalCartSelctedService?.serviceTotal?.serviceTotalAmount :  selectedAdonService?.serviceTotal?.serviceTotalAmount) || 0 | currency: usd}}</span>
                    </div>
                  </div>
                </div>
              </p-header>

              <div class="flex-column min-height-adon">
                <div class="border-bottom-lightest">
                  <div class="flex-row flex-between-center pb-3">
                    <span class="font-14 font-400 font-gray">Select service package</span>
                    <div class="w-50">
                      <app-dropdown id="select-adon" listId="select-adon-list" field="title" theme="border" label="Select adon package"
                        scrollHeight="170px" [closeOnSelection]="true" [isDropdownIconVisible]="true" placeholder="Select adon package"
                        [disabled]="isEditMode" [floatingLabel]="false" [searchFilter]="searchFilter" [fontSize]="14" [value]="isEditMode ? globalCartSelctedService : selectedAdonService"
                        [options]="adOnServicesObj?.adOnServices" [listData]="adOnServicesObj?.adOnServices" (appSelect)="handleAddOnService($event)">
                      </app-dropdown>
                    </div>
                  </div>
                </div>

                <!-- body section -->
                <div class="flex-column mt-3">
                  <!-- Header -->
                  <div class="adon-service-header flex-row font-14 font-600 w-100">
                    <span class="pl-0 ui-g-3">Name</span>
                    <span class="flex-end-center ui-g-2">Cost per unit</span>
                    <span class="flex-end-center ui-g-2">Price per unit</span>
                    <span class="flex-end-center ui-g-1">Qty&nbsp;/&nbsp;hrs</span>
                    <span class="flex-end-center ui-g-2" [hidden]="hideCost">Total cost</span>
                    <span class="flex-end-center pr-0 ui-g-2">Total Price</span>
                  </div>
                  <div class="adon-service-body flex-column">
                    <ng-container *ngFor="let adonServiceItem of (isEditMode ? globalCartSelctedService?.items : selectedAdonService?.items); let i = index">
                      <div class="font-14 font-400 flex-start-center">
                        <span class="pl-0 ui-g-3 flex-row gap-2">
                          <span class="flex-start-end">
                            <i class="font-gray far" [ngClass]="icons[adonServiceItem?.type]"></i>
                          </span>
                          <app-checkbox
                            [isChecked]="adonServiceItem.type === 'tireStorage' && this.isTireStorage2Enabled ? true : adonServiceItem?.checked"
                            [disabled]="isEditMode || adonServiceItem.type === 'tireStorage' && this.isTireStorage2Enabled"
                            (appChange)="handleAddOnItemChange('checked', $event, adonServiceItem)"
                            [inputId]="i">
                          </app-checkbox>
                          <span class="flex-start-end pointer" *ngIf="adonServiceItem?.type === 'bundle'" (click)="adonServiceItem.isExpanded = !adonServiceItem?.isExpanded;">
                            <i class="font-gray far" [ngClass]="{'fa-chevron-down': !adonServiceItem?.isExpanded, 'fa-chevron-up': adonServiceItem?.isExpanded }"></i>
                          </span>
                          <span class="text-truncate" [ngClass]="{'strike-through': !adonServiceItem?.checked, 'pointer': adonServiceItem?.type === 'bundle'}" [pTooltip]="adonServiceItem?.title" tooltipPosition="top" (click)="adonServiceItem?.type !== 'bundle' ? '' : adonServiceItem.isExpanded = !adonServiceItem?.isExpanded;">
                            {{adonServiceItem?.title}}
                          </span>
                        </span>
                        <span class="flex-end-center ui-g-2" [ngClass]="{'strike-through': !adonServiceItem?.checked}">{{(adonServiceItem?.cost || 0) | currency: usd}}</span>
                        <span class="flex-end-center ui-g-2" [ngClass]="{'strike-through': !adonServiceItem?.checked}">{{(adonServiceItem?.price || 0) | currency: usd}}</span>
                        <span class="flex-end-center ui-g-1 pl-3">
                          <app-input
                            placeholder="0"
                            [floatingLabel]="false"
                            [selectTextOnFocus]="true"
                            [disabled]="adonServiceItem?.type === 'bundle' || isEditMode"
                            theme="border"
                            [allowDecimal]="true"
                            [value]="adonServiceItem?.isCountFocus ? adonServiceItem?.count : (adonServiceItem?.count || 0) | number : '1.2-2'"
                            (appChange)="handleAddOnItemChange('count', $event, adonServiceItem)"
                            (appFocus)="handleAdOnServiceFocus('isCountFocus', adonServiceItem)"
                            (appBlur)="handleAdOnServiceBlur('isCountFocus', adonServiceItem)">
                          </app-input>
                        </span>
                        <!-- cost column -->
                        <span class="flex-end-center ui-g-2" [hidden]="hideCost" [ngClass]="{'strike-through': !adonServiceItem?.checked}">{{(adonServiceItem?.type === 'bundle' ? adonServiceItem?.cost || 0 : adonServiceItem?.cost * (adonServiceItem?.count || 0)) | currency: usd}}</span>
                        <span class="flex-end-center pr-0 ui-g-2" [ngClass]="{'strike-through': !adonServiceItem?.checked}">{{(adonServiceItem?.type === 'bundle' ? adonServiceItem?.flatRate || 0 : adonServiceItem?.price * (adonServiceItem?.count || 0)) | currency: usd}}</span>
                      </div>
                      <!-- Flat rate section -->
                      <ng-container *ngIf="adonServiceItem?.type === 'bundle'">
                        <div class="font-14 font-400 flex-start-center" *ngFor="let subItem of adonServiceItem?.subItems" [hidden]="!adonServiceItem?.isExpanded">
                          <span class="pl-4 ui-g-3 flex-row gap-2">
                            <span class="flex-start-end">
                              <i class="font-gray far" [ngClass]="icons[subItem?.type]"></i>
                            </span>
                            <span class="text-truncate" [ngClass]="{'strike-through': !adonServiceItem?.checked}" [pTooltip]="adonServiceItem?.title" tooltipPosition="top">
                              {{subItem?.title}}
                            </span>
                          </span>
                          <span class="flex-end-center ui-g-2" [ngClass]="{'strike-through': !adonServiceItem?.checked}">{{(subItem?.cost || 0) | currency: usd}}</span>
                          <span class="flex-end-center ui-g-2" [ngClass]="{'strike-through': !adonServiceItem?.checked}">{{(subItem?.price || 0) | currency: usd}}</span>
                          <span class="flex-end-center ui-g-1 pl-3">
                            <app-input
                              placeholder="0"
                              [floatingLabel]="false"
                              [selectTextOnFocus]="true"
                              [disabled]="true"
                              theme="border"
                              [allowDecimal]="true"
                              [value]="(subItem?.count || 0) | number : '1.2-2'">
                            </app-input>
                          </span>
                          <!-- cost column -->
                          <span class="flex-end-center ui-g-2" [hidden]="hideCost" [ngClass]="{'strike-through': !adonServiceItem?.checked}">{{subItem?.cost * (subItem?.count || 0) | currency: usd}}</span>
                          <span class="flex-end-center pr-0 ui-g-2" [ngClass]="{'strike-through': !adonServiceItem?.checked}">{{(subItem?.flatRateAmount || 0) | currency: usd}}</span>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </p-accordionTab>
          </p-accordion>
      </div>



    </div>

    <div class="cart-footer py-1 border-top-lightest">
      <div class="flex-between-center p-2 pr-3 pl-3">
        <div class="flex-row gap-2">
          <span class="font-14 font-600 flex-start-center">Out-the-door price:</span>
          <span class="flex-start-center">
            <span class="font-18 font-700">{{(outTheDoorPrice || 0) | currency: usd}}</span>
            <span class="font-14 font-600 pl-1">({{cartOrderTotal || 0 | currency : usd}} + {{(isEditMode ? globalCartSelctedService?.serviceTotal?.serviceTotalAmount :  selectedAdonService?.serviceTotal?.serviceTotalAmount) || 0 | currency: usd}})</span>
          </span>
        </div>

        <div>
            <button class="btn btn-primary btn-block" *ngIf="!isOpenFromQuickTireLookup"
            [disabled]="!isAllCountAvailable || isSubmitting || isShippingCalculating" (click)="handleSaveCart('go-to-estimate')">
            Go to estimate
            <i *ngIf="isSubmitting || isShippingCalculating" class="fal fa-spinner rotate ml-2"></i>
          </button>

          <button class="btn btn-primary btn-block" *ngIf="isOpenFromQuickTireLookup"
            [disabled]="(source !== 'autoleap' && isShippingCalculating) || !isAllCountAvailable"
            (click)="handleAddCustomerAndVehicleCart('add-customer-vehicle')">{{isRunTireStorageFlow ? 'Add to RO and return to appointment' : 'Add customer and vehicle'}}
            <i *ngIf="isSubmitting || isShippingCalculating" class="fal fa-spinner rotate ml-2"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
